import React from 'react'
import AppNav from './AppNav'

// The Home Component will display the name, title and tagline for the portfolio owner
// inside a hero container (from bulma) and will display the homepage version of the navbar
export default function Home({ name, title, tagline, children }) {

    // useState variable to open or close the modal
    const [modal, setModal] = React.useState({ active: null, rootOnClick: null })

    // callback function to launch the modal and close the modal, from bulma
    const openModal = ev => setModal({ active: 'is-active', rootOnClick: closeModal })

    // used for when the user clicks the background and we do not need the event to bubble up
    const closeModal = ev => setModal({ active: null, rootOnClick: null })

    return (
        <section className="Home hero is-info is-fullheight image-background" onClick={modal.rootOnClick}>
            <img src='imgs/hero-cover.jpg' alt="background of carleton traintracks" className="hero-image" />
            {/* Hero Header - contains links to other pages */}
            <div className="hero-head">
                <AppNav homepage={true} />
            </div>

            {/* Hero Body */}
            <div className="hero-body">
                <div className="container has-text-centered">
                    <h1 className="title animate-hover-bounce" onClick={openModal}>{name}</h1>
                    <h2 className="subtitle">
                        {title}<br />{tagline}
                    </h2>
                    <div className="buttons social is-centered">
                        {/* Link to send an email */}
                        <a href="mailto:racvic.rachamalla@gmail.com?Subject=Hello" className="button is-large gmail animate-spin" title="Send me an email to my Gmail">
                            <span className="icon has-text-white">
                                <i className="fab fa-google"></i>
                            </span>
                        </a>

                        {/* Link to github profile */}
                        <a href="https://github.com/rach0022" className="button is-large github animate-spin-reverse" title="Check out my Github Profile">
                            <span className="icon">
                                <i className="fab fa-github"></i>
                            </span>
                        </a>
                    </div>
                </div>
            </div>

            {/* The modal showing current status of the site */}
            <div className={`modal ${modal.active}`}>
                <div className="modal-background"></div>
                <div className="modal-content">
                    {children}
                </div>
                <button className="modal-close is-large" aria-label="close" onClick={closeModal}></button>
            </div>
        </section>
    )
}
